import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function creative({ attributes, docSections }) {
    const { articlesNumber, col, docs_layout, docId, orderBy, child_docs_order, } = attributes;

    // Determine layout type
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : "ezd-masonry-wrap";

    const post = useSelect((select) => {
        return select("core").getEntityRecord("postType", "docs", docId);
    }, [docId]);

    useEffect(() => {
        if (post) {
            console.log("Post Title:", post.title.rendered);
        } else {
            console.log("Post not found or still loading.");
        }
    }, [post]);
    
    // Fetch all doc items for each section in a single call
    const allDocItems = useSelect((select) => {
        const parentIds = docSections?.map((section) => section.id) || [];
        return parentIds.map((parentId) => ({
            parentId,
            items: select('core').getEntityRecords('postType', 'docs', {
                per_page: articlesNumber,
                orderby: orderBy,
                order: child_docs_order,
                parent: parentId,
                status: ['publish', 'private']
            }),
        }));
    }, [articlesNumber,orderBy,child_docs_order, docSections]);

    // Render the component
    return (
        <div className="docs-box-item docs-single-5-wrap doc-box-style">

            <h5 className="docs-5-title"> {post ? post.title.rendered : ''}  </h5>

            <div className="dox5-section-item">
                {docSections && Array.isArray(docSections) && docSections.map((section) => {
                    const { title, id } = section;

                    // Find the child items for the current section
                    const sectionItems = allDocItems.find((item) => item.parentId === id)?.items || [];

                    return (
                        <div className="section5-article" key={id}>
                            <div className="section5-section-title">
                                <h6>{title && title.rendered ? title.rendered : "No Title Available"}</h6>
                            </div>

                            <ul className="navbar-nav docs-single5-nav-wrap ezd-list-unstyled">
                                {sectionItems && Array.isArray(sectionItems) && sectionItems.map((item) => (
                                    <li key={item.id}>
                                        <a href="#">
                                            {item.title && item.title.rendered ? item.title.rendered : "Untitled"}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
